<template>
  <back-office-form
    :inputs="inputs"
    :item="version"
    :delete-button-label="this.$t('versions.delete')"
    :mode="mode"
    :modes="modes"
    :delete-confirmation-needed="false"
    @submit="handleSubmit"
    @delete="handleDelete"
  />
</template>

<script>
  import GameSelect from '@/components/GameSelect'
  import BackOfficeForm from '@/components/BackOfficeForm'
  import GameJurisdictions from "@/components/GameJurisdictions";
  import NumberListInput from "@/components/NumberListInput"

  export default {
    name: 'VersionForm',
    components: { BackOfficeForm },
    props: {
      version: {
        type: Object,
        default: () => {
          return {}
        }
      },
      mode: {
        type: String,
        required: true
      }
    },
    methods: {
      handleSubmit (...rest) {
        this.$emit('submit', ...rest)
      },
      handleDelete () {
        this.$emit('delete')
      }
    },
    computed: {
      modes (){
        return {
          create: {
            title: 'versions.add',
            subtitles: ['versions.addDescription']
          },
          edit: {
            title: 'versions.edit',
            subtitles: ['']
          },
        }
      },
      inputs () {
        return [
          {
            name: 'gameId',
            is: GameSelect,
            validators: 'required',
            disabled: this.mode === 'edit',
            properties: {
              label: this.$t('common.game')
            }
          },
          {
            name: 'version',
            validators: 'required',
            properties: {
              placeholder: this.$t('versions.versionPlaceholder'),
              label: this.$t('common.version')
            }
          },
          {
            name: 'frontendUrl',
            validators: 'required',
            properties: {
              placeholder: this.$t('versions.frontendUrlPlaceholder'),
              label: this.$t('versions.frontendUrl')
            }
          },
          {
            name: 'backendUrl',
            validators: 'required',
            properties: {
              placeholder: this.$t('versions.backendUrlPlaceholder'),
              label: this.$t('versions.backendUrl')
            }
          },
          {
            name: 'historyUrl',
            properties: {
              placeholder: this.$t('versions.historyUrlPlaceholder'),
              label: this.$t('versions.historyUrl')
            }
          },
          {
            name: 'jurisdictions',
            is: GameJurisdictions,
            componentProperties: {
              value: it => it.jurisdictions.map(it => it.id),
            },
          },
          {
            name: 'betSizes',
            is: NumberListInput,
            properties: {
              placeholder: this.$t('versions.betSizesPlaceHolder'),
              label: this.$t('versions.betSizes')
            }
          },
        ]
      }
    }
  }
</script>
